import React from 'react'
import LessThan600 from './LessThan600'
import BiggerThan960 from './BiggerThan960'
import {compose, lifecycle, withHandlers, withState} from 'recompose'
import styled from 'styled-components'
import * as media from '../../media'
import _ from 'lodash'
import getUrl from "../../getUrl";

const LessThan600Check = styled.div`
  ${media.biggerThan(600)`display:none;`}
`

const LessThan760Check = styled.div`
  ${media.biggerThan(761)`display:none;`}
  ${media.smallerThan(600)`display:none;`}  
`

const LessThan960Check = styled.div`
  ${media.biggerThan(961)`display:none;`}
  ${media.smallerThan(760)`display:none;`}  
`

const BiggerThan960Check = styled.div`
  ${media.smallerThan(960)`display:none;`}
`

const Sticky = styled.div`
  position: sticky;
  top: 0;
  z-index: 10;
  width: 100vw;
  max-width: 100%;
  ${media.smallerThan(960)`z-index: 10; top: 90px;`}
`;

const Search = (props) => {
  return (
    <Sticky>
      <LessThan600Check>
        <LessThan600 {...props} />
      </LessThan600Check>
      <LessThan760Check>
        <LessThan600 {...props} />
      </LessThan760Check>
      <LessThan960Check>
        <LessThan600 {...props} />
      </LessThan960Check>
      <BiggerThan960Check>
        <BiggerThan960 {...props} />
      </BiggerThan960Check>
    </Sticky>
  )
}

const enhance = compose(
  withState('menuShown', 'setMenuShown', false),
  withState('active', 'setActive', false),
  withState('article', 'setArticle', ''),
  withState('manufacture', 'updateManufacture', ''),
  withState('generation', 'updateGeneration', ''),
  withState('model', 'updateModel', ''),
  withState('variant', 'updateVariant', ''),
  withState('engine', 'updateEngine', ''),

  withState('manufactures', 'setManufactures', ''),
  withState('generations', 'setGenerations', ''),
  withState('models', 'setModels', ''),
  withState('variants', 'setVariants', ''),
  withState('engines', 'setEngines', ''),

  withState('loadingManufactures', 'setLoadingManufactures', true),
  withState('loadingGenerations', 'setLoadingGenerations', false),
  withState('loadingModels', 'setLoadingModels', false),
  withState('loadingVariants', 'setLoadingVariants', false),
  withState('loadingEngines', 'setLoadingEngines', false),

  withHandlers({
    setManufacture: ({ setModels, updateModel, updateVariant, updateEngine, updateGeneration, updateManufacture, setLoadingModels }) => (manufacture) => {
      setLoadingModels(true)
      updateManufacture(_.get(manufacture, 'id'))
      updateModel('')
      updateVariant('')
      updateGeneration('')
      updateEngine('')
      fetch(getUrl(`/cat/v1/dict/model?limit=1000&manufacturer_id=${_.get(manufacture, 'id')}`)).then(data => {
        return data.json()
      }).then (models => {
        setModels(_.get(models, 'data.data', []))
        setLoadingModels(false)
      }).catch(err => {
        console.log(err)
      })
    },

    setModel: ({ setGenerations, updateModel, updateVariant, updateEngine, updateGeneration, setLoadingGenerations }) => (model) => {
      setLoadingGenerations(true)
      updateModel(_.get(model, 'id'))
      updateVariant('')
      updateEngine('')
      updateGeneration('')
      fetch(getUrl(`/cat/v1/dict/generation?limit=1000&model_id=${_.get(model, 'id')}`)).then(data => {
        return data.json()
      }).then (generations => {
        setGenerations(_.get(generations, 'data.data', []))
        setLoadingGenerations(false)
      }).catch(err => {
        console.log(err)
      })
    },

    setGeneration: ({ setVariants, updateGeneration, updateVariant, updateEngine, setLoadingVariants }) => (generation) => {
      setLoadingVariants(true)
      updateGeneration(_.get(generation, 'id'))
      updateVariant('')
      updateEngine('')
      fetch(getUrl(`/cat/v1/dict/variant?limit=1000&generation_id=${_.get(generation, 'id')}&columns=date_start,date_end,id,engine_list`))
        .then(data => {
          return data.json()
        }).then(variants => {
          let data = _.get(variants, 'data.data', [])
          data = data.map(e => {
            return { ...e, name: `${e.date_start} - ${e.date_end || 'настоящее время'}` }
          })
          setVariants(data)
          setLoadingVariants(false)
        }).catch(err => {
          console.log(err)
        })
    },

    setVariant: ({ setEngines, updateVariant, updateEngine, setLoadingEngines }) => (variant) => {
      setLoadingEngines(true)
      updateVariant(_.get(variant, 'id'))
      updateEngine('')
      fetch(getUrl(`/cat/v1/dict/engine?limit=1000&variant_id=${_.get(variant, 'id')}`))
        .then(data => {
          return data.json()
        }).then(engines => {
          setEngines(_.get(engines, 'data.data', []))
          setLoadingEngines(false)
        }).catch(err => {
          console.log(err)
        })
    },

    setEngine: ({ updateEngine }) => (engine) => {
        if (engine) {
            updateEngine(engine.id)
        }
    }
  }),
  lifecycle({
    componentWillUpdate(nextProps) {
      if (this.props.location !== nextProps.location && nextProps.location !== '/selection') {
        this.props.setManufacture('')
      }
      if (this.props.location !== nextProps.location && !nextProps.location.startsWith('/article')) {
        this.props.setArticle('')
      }
    },
    componentDidMount() {
      fetch(getUrl(`/cat/v1/dict/manufact?limit=1000`)).then(data => {
        return data.json()
      }).then (manufactures => {
        this.props.setManufactures(_.get(manufactures, 'data.data', []))
        this.props.setLoadingManufactures(false)
      }).catch(err => {
        console.log(err)
      })
    }
  })
)

export default enhance(Search)




// WEBPACK FOOTER //
// ./src/finwhale/search/index.js